import React from "react";

import { useTranslation } from "react-i18next";
import StatusBackground from "src/components/StatusBackground";
import TitleSection from "src/components/TitleSection/TitleSection";
import styled from "styled-components";

const Unsubscribed = () => {
  const { t } = useTranslation();
  return (
    <StatusBackground>
      <Div className="text-center">
        <TitleSection
          title={t("unsubscribed.title")}
          text={t("unsubscribed.subtitle")}
        />
        <p>{t("unsubscribed.message")}</p>
        <p>{t("unsubscribed.resubscribe")}</p>
      </Div>
    </StatusBackground>
  );
};

const Div = styled.div`
  background: rgba(0, 0, 0, 0.5);
  padding: 1rem;
`;

export default Unsubscribed;
